module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/de1b3e675e8471510c39fc8d9bbadc4d.png";